<script type="text/javascript">

  export default {
    props: ['item', 'versions', 'website'],
    data() {
      return {
        iframeWidth: 100,
        iframeHeight: 65,
        htmlOutput: '',
        select_version: ''
      }
    },
    watch: {
      // item: { handler(n, o) { this.updateIframe(); }, deep: true },
      // website: { handler(n, o) { this.updateIframe(); }, deep: true },
    },
    mounted() {
      // this.updateIframe();
    },
    created() {
      this.select_version = JSON.parse(JSON.stringify(this.item.id));
      // document.domain = 'localhost';
      this.$noty.success("Loading the live page.");
    },
    methods: {
      updateIframe() {
        console.log('updating iframe');
        var iframeContent = document.getElementById('page_preview_contents').innerHTML;
        // let stylesHtml = ''; for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) { stylesHtml += node.outerHTML; }
        // let jsHtml = ''; for (const node of [...document.querySelectorAll('script[type="text/javascript"]')]) { jsHtml += node.outerHTML; }
        // this.htmlOutput = `<!DOCTYPE html>
        // <html>
        //   <head>
        //     <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.6.1/css/all.css" integrity="sha384-gfdkjb5BdAXd+lj+gudLWI+BXq4IuLW5IT+brZEZsLFm++aCMlF1V92rMkPaX4PP" crossorigin="anonymous">
        //     <style type="text/css">body{pointer-events:none}.docs{padding-right:40px !important}.docs_qnav{display:none}</style>
        //     ${stylesHtml}
        //   </head>
        //   <body>
        //     ${iframeContent}
        //     ${jsHtml}
        //   </body>
        // </html>`;

        // document.getElementById("myiframe").contentWindow.document.getElementById("mainContent").innerHTML = iframeContent;
        // this.$noty.success("Overwriting live page with current data.");
      }
    }
  }
</script>

<template>
  <div class="">

    <div id="page_preview_contents" ref="page_preview_contents" class="position-relative mb-5 d-none">
      <w-site-navbar v-if="item.navbar && !isAdmin" :website="website"></w-site-navbar>
      <!-- <div v-for="(section, section_i) in item.content" :key="section_i">
        <component v-if="widgets.includes('w-'+section.type)" :is="'w-'+section.type" :pc="section" :website="website" @done="updateIframe()"></component>
      </div> -->
      <div v-if="!item.content" class="py-7 bg-dark"></div>
      <div v-if="!item.content" class="py-7"></div>
      <w-site-footer v-if="item.footer && !isAdmin" :website="website"></w-site-footer>
    </div>

    <div class="row mb-4">
      <div class="col-sm-8">
        <w-field SimpleDataType="String List, Single" v-model="select_version" title="Version : " :Options="versions"></w-field>
      </div>
      <div class="col-sm-2">
        <w-field SimpleDataType="Number" Title="Width : " Min="5" Max="100" v-model="iframeWidth" lang=""></w-field>
      </div>
      <div class="col-sm-2">
        <w-field SimpleDataType="Number" Title="Height : " Min="5" Max="100" v-model="iframeHeight" lang=""></w-field>
      </div>
    </div>

    <div class="row">
      <!-- <div class="_w-100">
        <w-field SimpleDataType="Number" Title="Width : " Min="5" Max="100" v-model="iframeWidth" lang=""></w-field>
        <w-field SimpleDataType="Number" Title="Height : " Min="5" Max="100" v-model="iframeHeight" lang=""></w-field>
      </div> -->
      <div class="col">
        <div v-if="item.slug.includes(':id')" class="alert alert-danger">
          Dynamic slug pages with :id unfortunatly cannot be previewed.
        </div>
        <!-- <iframe :srcdoc="htmlOutput" frameborder="0" :style="'width:'+iframeWidth+'%;'+'height:'+iframeHeight+'vh;'+'box-shadow: 0 0 10px rgba(0,0,0,0.5);border-radius:5px;'"></iframe> -->
        <iframe id="myiframe" :src="website.website_domain+item.slug+'?model_id='+select_version" frameborder="0" :style="'width:'+iframeWidth+'%;'+'height:'+iframeHeight+'vh;'+'box-shadow: 0 0 10px rgba(0,0,0,0.5);border-radius:5px;'" @load="updateIframe()"></iframe>
      </div>
    </div>

  </div>
</template>
